<template>
  <div class="app-container">
    <div class="top-content">
      <div class="bg-content">
        <img class="image" :src="headerData.backgroundImageUrl"/>
      </div>
      <div class="top-text">
        <div class="title">{{ headerData.title }}</div>
        <div class="subtitle">{{ headerData.subTitle }}</div>
      </div>
    </div>
    <div class="tab-box">
      <div class="tab-content" :style="{ width: tabArr.length * 220 + 'px' }">
        <div v-for="(item, index) in tabArr" :key="index" class="tab-item">
          <div
            @click="onTabClick(index)"
            :class="active === index ? 'item-select' : 'item'"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="scrollTop >= 460" class="tab-box tab-box-fixed">
      <div class="tab-content" :style="{ width: tabArr.length * 220 + 'px' }">
        <div v-for="(item, index) in tabArr" :key="index" class="tab-item">
          <div
            @click="onTabClick(index)"
            :class="active === index ? 'item-select' : 'item'"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="middle-content">
      <div
        class="middle-item"
        v-for="(item, index) in tabArr"
        :key="index"
        :id="'target' + index"
      >
        <div class="title">{{ item.name }}</div>
        <div class="list-box">
          <div
            v-for="(it, ind) in item.softFileList"
            :key="ind"
            class="item-list"
          >
            <div class="list-image">
              <img class="image" :src="it.iconPath"/>
            </div>
            <div class="list-middle">
              <div class="name">{{ it.name }}</div>
              <div class="desc">{{ it.description }}</div>
            </div>
            <div v-if="it.qrcode" class="list-btn" @click="onDownQrcodeClick(it)">
              <div class="btn-image">
                <img class="image" :src="item.imageUrl"/>
              </div>
              <div class="btn-down">立即下载</div>
            </div>
            <div v-else class="list-btn" @click="onDownUrlClick(it)">
              <div class="btn-image">
                <img class="image" :src="item.imageUrl"/>
              </div>
              <a :href="it.filePath" class="btn-down"
              >立即下载</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <down-load ref="downLoad" :dialogVisible.sync="downLoadVisible"/>
  </div>
</template>
<script>
import path from "path";
import DownLoad from "./components/downloaddialog.vue";
import {getDownloadHeader, getDownloadList} from "@/api/download";
import {EventBus} from "@/utils/eventbus.js";

export default {
  name: "DownManageDialog",
  components: {
    DownLoad,
  },
  data() {
    return {
      position: "",
      active: 0,
      downLoadVisible: false,
      headerData: {},
      tabArr: [],
      scrollTop: 0,
    };
  },
  mounted() {
    if (this.$route.query.position) {
      const position = this.$route.query.position;
      if (Number(position) === 0) {
        this.position = "windows";
      } else if (Number(position) === 1) {
        this.position = "ios";
      } else {
        this.position = "android";
      }
    }
    this._getDownloadHeader();
    this._getDownloadList();
    window.addEventListener("scroll", this.handleScroll);
    EventBus.$on("onDownClick", (position) => {
      if (Number(position) === 0) {
        this.position = "windows";
      } else if (Number(position) === 1) {
        this.position = "ios";
      } else {
        this.position = "android";
      }
      this.tabArr.forEach((element, index) => {
        if (element.name.toLowerCase() === this.position) {
          document.getElementById("target" + index).scrollIntoView({
            block: "start",
            inline: "nearest",
          });
          window.scrollBy({top: -100});
        }
      });
    });
  },
  beforeDestroy() {
    EventBus.$off("onDownClick");
  },
  methods: {
    onTabClick(index) {
      this.active = index;
      document.getElementById("target" + index).scrollIntoView({
        block: "start",
        inline: "nearest",
      });
      window.scrollBy({top: -100});
    },
    onDownUrlClick(item) {
      if (item != null && item.filePath != null && item.filePath != "") {
        let link = document.createComment('a');
        link.style.display = 'none';
        link.href = item.filePath;
        link.download = path.basename(item.filePath);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

    },
    onDownQrcodeClick(item) {
      const {qrcode} = item;
      if (!qrcode) return;
      this.$refs.downLoad.parentHandleclick(item);
      this.downLoadVisible = true;
    },

    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.scrollTop = scrollTop;
    },
    //封头配置
    _getDownloadHeader() {
      getDownloadHeader()
        .then((res) => {
          const {data} = res;
          this.headerData = {...data};
        })
        .catch((res) => {
        })
        .finally(() => {
        });
    },
    //软件列表
    _getDownloadList() {
      getDownloadList()
        .then((res) => {
          const {data} = res;
          this.tabArr = [...data];
          if (this.position) {
            setTimeout(() => {
              this.tabArr.forEach((element, index) => {
                if (element.name.toLowerCase() === this.position) {
                  this.active = index;
                  document.getElementById("target" + index).scrollIntoView({
                    block: "start",
                    inline: "nearest",
                  });
                  window.scrollBy({top: -100});
                }
              });
            }, 1000);
          }
        })
        .catch((res) => {
        })
        .finally(() => {
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  margin-top: -120px;

  .top-content {
    position: relative;
    height: 460px;

    .bg-content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;

      .image {
        width: 100%;
        height: 460px;
      }
    }

    .top-text {
      position: absolute;
      bottom: 100px;
      left: 0;
      right: 0;

      .title {
        color: #ffffff;
        font-size: 72px;
        font-weight: 700;
      }

      .subtitle {
        font-size: 24px;
        margin-top: 6px;
        color: rgba(255, 255, 255, 0.8);
        font-weight: 400;
      }
    }
  }

  .tab-box {
    max-width: 1920px;
    height: 70px;
    background-color: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(16, 130, 255, 0.3);
    padding-left: 50px;
    padding-right: 50px;
    overflow-y: hidden;
    overflow-x: hidden;

    .tab-content {
      display: flex;
      margin: 0 auto;
      justify-content: center;

      .tab-item {
        width: 220px;
        line-height: 67px;
      }

      .item,
      .item-select {
        cursor: pointer;
        font-size: 20px;
        color: #333333;
      }

      .item-select {
        font-size: 20px;
        color: #1082ff;
        display: inline-block;
        border-bottom: 3px solid #1082ff;
      }
    }
  }

  .tab-box:hover {
    overflow-x: auto;
  }

  .tab-box-fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
  }

  .middle-content {
    background-color: #f5f5f5;
    margin-top: 4px;
    min-height: 500px;
    padding-top: 20px;
    padding-bottom: 120px;

    .middle-item {
      width: 1320px;
      margin: 0 auto;
      text-align: left;
      margin-top: 70px;

      .title {
        font-size: 36px;
        color: #333333;
        font-weight: 700;
        margin-bottom: -10px;
      }

      .list-box {
        display: flex;
        flex-wrap: wrap;

        .item-list {
          width: 50%;
          margin-top: 50px;
          display: flex;
          align-items: center;

          .list-image {
            .image {
              width: 100px;
              border-radius: 10px;
              height: 100px;
            }
          }

          .list-middle {
            width: 238px;
            margin-left: 30px;

            .name {
              color: #333333;
              font-size: 30px;
            }

            .desc {
              font-size: 18px;
              margin-top: 10px;
              color: #333333;
            }
          }

          .list-btn {
            margin-left: 49px;
            width: 160px;
            height: 50px;
            background-color: #666666;
            border-radius: 35px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            .btn-image {
              .image {
                vertical-align: middle;
                width: 24px;
              }
            }

            .btn-down {
              margin-left: 10px;
              font-size: 18px;
              color: #ffffff;
              text-decoration: none;
            }
          }

          .list-btn:hover {
            background-color: #1082ff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/downmanage/index.vue